import React, { useEffect, useRef } from "react";
import { AppState } from "../../AppState/appState";
import "./Dashboard.css";
import Grid from "@mui/material/Grid";
import SearchWithBarcode from "../../components/search/searchDashboard";
import KRACard from "../../components/kraCard/KRACard";
import { getDashboardKRA } from "../../API/getDashboardKRA";
import { useDispatch, useSelector } from "react-redux";
import { AppURLs, ETab } from "../../constants";
import Loader from "../../components/loader/loader";
import { TDashboardKRA } from "../../models/dashboard";
import { FooterTabPosition } from "../../AppState/footerTabPosition";
import { TTerminal } from "../../AppState/overagesFilterFormActions";
import { resetState } from "../../AppState/resetStateActions";
import usePermissions from "../../@hooks/usePermissions";

function Dashboard() {
  const dispatch = useDispatch();
  const [countKRA, setCountKRA] = React.useState<TDashboardKRA>();
  const currentTerminalValue = useSelector(
    (state: AppState) => state.activeTerminal,
  );
  const previousTerminalValue = useRef<TTerminal | null>(null);
  const terminals = useSelector((state: AppState) => state.terminalMaster);

  const permissions = usePermissions();
  const [pageLoading, setPageLoading] = React.useState<boolean>(false);

  //Dashboard KRA API call
  const getDashboardKRAdata = async () => {
    setPageLoading(true);
    const terminalList: string[] =
      currentTerminalValue?.region === null
        ? terminals
            .filter(
              (terminal) =>
                terminal?.region === currentTerminalValue?.terminalId,
            )
            .map((t) => t.terminalId)
        : [currentTerminalValue?.terminalId];
    let params: any = {
      terminal: terminalList?.[0] === "All" ? [] : terminalList,
    };
    getDashboardKRA(params)
      .then((results: any) => {
        setPageLoading(false);
        setCountKRA(results);
      })
      .catch((err) => {
        setPageLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {
    // Function to handle the data fetch
    const fetchDashboardData = () => {
      if (
        currentTerminalValue?.terminalId !== "" &&
        currentTerminalValue !== previousTerminalValue.current
      ) {
        getDashboardKRAdata();
      }
    };

    // Call fetchDashboardData on component mount or when navigating back to this page
    fetchDashboardData();

    // Update previous terminal value after fetching data
    previousTerminalValue.current = currentTerminalValue;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTerminalValue]);

  useEffect(() => {
    dispatch(resetState("DASHBOARD_SEARCH_FILTER_RESET"));
    dispatch(FooterTabPosition(ETab.dashboard));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <div className="layout" data-test="dashboard">
      <Grid container className="center-container dashboard">
        <Grid item xl={6} md={6} sm={8}>
          <h2>What would you like to find today?</h2>

          {/* Search Filter  */}
          <SearchWithBarcode />
        </Grid>
      </Grid>

      {/* Cards Container */}
      <Grid
        container
        className="center-container card-container"
        data-testid="kra-cards-container"
      >
        <Grid
          item
          className="card-bg"
          data-testid="my-assignments-grid"
        >
          <KRACard
            data-testid="my-assignments-card"
            navigateTo={AppURLs.myAssignments}
            heading={"My Assignments"}
            data={countKRA?.myAssignments}
          />
        </Grid>
        {permissions.overages && (
          <Grid
            item
            className="card-bg"
            data-testid="overages-grid"
          >
            <KRACard
              data-testid="overages-card"
              navigateTo={AppURLs.overages}
              heading={"Overages"}
              data={countKRA?.overages}
            />
          </Grid>
        )}
        {permissions.shortages && (
          <Grid
            item
            className="card-bg"
            data-testid="shortages-grid"
          >
            <KRACard
              data-testid="shortages-card"
              navigateTo={AppURLs.shortages}
              heading={"Shortages"}
              data={countKRA?.shortages}
            />
          </Grid>
        )}

        {permissions.damages && (
          <Grid
            item
            className="card-bg"
            data-testid="damages-grid"
          >
            <KRACard
              data-testid="damages-card"
              navigateTo={AppURLs.damages}
              heading={"Damages / Refusals"}
              data={countKRA?.damages}
            />
          </Grid>
        )}
        {permissions.onHandDelivery && (
          <Grid
            item
            className="card-bg"
            data-testid="on-hand-grid"
          >
            <KRACard
              data-testid="on-hand-card"
              navigateTo={AppURLs.onHandDelivery}
              heading={"On Hand"}
              data={countKRA?.onHandDelivery}
            />
          </Grid>
        )}
        {permissions.misDelivery && (
          <Grid item className="card-bg">
            <KRACard
              data-test="KRAcard"
              navigateTo={AppURLs.misdelivery}
              heading={"Misdelivery"}
              data={countKRA?.misDelivery}
            />
          </Grid>
        )}

        {permissions.cleared && (
          <Grid item className="card-bg">
            <KRACard
              data-test="KRAcard"
              navigateTo={AppURLs.cleared}
              heading={"Cleared"}
              data={countKRA?.cleared}
            />
          </Grid>
        )}
      </Grid>
      <Loader pageLoader={pageLoading}></Loader>
    </div>
  );
}

export default Dashboard;
